<template>
    <div>
    <el-popover trigger="hover" placement="right"> 
        <template>
             <el-table ref="taskTable" :data="taskInstanceList" style="width: 100%" :border="true">
                <el-table-column prop="name" width="220" label="任务名称" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                      <el-tag  v-if="!scope.row.hasOwnProperty('taskUser')" type="danger" size="small">{{ scope.row.name }}</el-tag>
                      <el-tag style="cursor:pointer;"  v-else-if="scope.row.hasOwnProperty('taskUser') " @click="checkTaskDetail(scope.row)" type="primary" size="small">{{ scope.row.name }}</el-tag>
                      <el-tag  v-else type="info" size="small">{{ scope.row.name}}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="任务负责人" width="150">
                   <template slot-scope="scope">
                      <el-tag  v-if="!scope.row.hasOwnProperty('taskUser')" type="danger" size="small">未分配任务负责人</el-tag>
                      <el-tag  style="cursor:pointer;" v-else-if="scope.row.hasOwnProperty('taskUser') " @click="checkTaskDetail(scope.row)" type="primary" size="small">{{ scope.row.taskUser.trueName }}</el-tag>
                      <el-tag  v-else type="info" size="small">{{ scope.row.taskUser.trueName }}</el-tag>
                   </template>
                </el-table-column>
                <el-table-column label="催办状态" width="100">
                   <template slot-scope="scope">
                      <el-tag  v-if="scope.row.hasOwnProperty('urgeCnt') && scope.row.urgeCnt>0" type="danger" size="small">已催办</el-tag>
                      <el-tag  v-else type="info" size="small">未催办</el-tag>
                   </template>
                </el-table-column>
                <el-table-column prop="created" label="任务开始时间" :sortable="true" width="150"></el-table-column>
                <el-table-column   label="操作"> 
                  <template slot-scope="scope">
                        <el-button size="mini" icon="el-icon-bell" v-if="scope.row.hasOwnProperty('urgeCnt') && scope.row.urgeCnt==0" title="催办" circle @click="sendUrgeMessage(scope.row)"></el-button>
                        <el-button size="mini" icon="el-icon-bell" v-if="scope.row.hasOwnProperty('urgeCnt') && scope.row.urgeCnt>0" title="再次催办" circle @click="sendUrgeMessage(scope.row)"></el-button>
                  </template>
                </el-table-column>
            </el-table>
        </template>
        <div slot="reference" class="name-wrapper">
            <!-- <el-tag  type="info" size="medium">{{taskInstanceList[0].name | ellipsis }}</el-tag> -->
            <el-tag  type="success" size="medium">{{taskInstanceList[0].name}}</el-tag>
        </div>
    </el-popover>
     <el-dialog
          title="流程详情"
          :fullscreen="true"
          append-to-body
          :visible.sync="isShowProcessInstanceDetail"
          >
         <ProcessDetail
            v-if="isShowDetail"
            :key="loadTimer"
            :instances="instancesInfo"
            :isRead="true"
          />
        </el-dialog>
        <el-dialog
            title="任务详情"
            :fullscreen="true"
            append-to-body
            :visible.sync="isShowTaskDetail"
            >
             <div style="margin-top: -20px;">
              <TaskDetail
                  class="popDetailTaskClass"
                  ref="taskDetailRef"
                  :taskInfo="taskInfo"
                  :isRead="true"
              />
             </div>
        </el-dialog>
    </div>
</template>

<script>
  import ProcessDetail from '@/pages/process/MyProcess/ProcessDetail';
  import { sendUrgeMessage, getProcessInstancesDetail, getProcessTaskDetail } from '@/data-model';
  export default {
      components: {
          ProcessDetail
      },
      filters: {
          ellipsis: function (value) {
              if (!value) return '';
              if (value.length > 5) {
                  return value.slice(0, 5) + '...';
              }
              return value;
          }
      },
      data () {
          return {
              taskInfo: {},
              isShowTaskDetail: false,
              // taskInstanceList: [],
              loadTimer: '',
              isShowDetail: false,
              isShowProcessInstanceDetail: false,
              instancesInfo: {},
              currentUserInfo: {}
          };
      },
      props: {
          taskInstanceList: {
              type: Array,
              default: () => { return []; }
          },
          isShowOverflowTooltip: {
              type: Boolean,
              default: false
          },
          column: {
              type: Object
          },
          cellValue: {
              type: String,
              default: ''
          },
          processInstanceName: {
              type: String,
              default: ''
          },
          processInstanceId: {
              type: String,
              default: ''
          },
          createdByName: {
              type: String,
              default: ''
          },
          createdDate: {
              type: String,
              default: ''
          },
          isFromBusTab: {
              type: Boolean,
              default: false
          },
          readOnly: {
              type: Boolean,
              default: false
          }
      },
      created () {
          this.isShowProcessInstanceDetail = false;
          let currentUserStr = sessionStorage.getItem('currentUserInfo');
          this.currentUserInfo = JSON.parse(currentUserStr);
          // this.taskInstanceList = [];
          // let processObj = { processInstanceId: this.processInstanceId, taskInstanceName: this.taskInstanceName, createdByName: this.createdByName, createdDate: this.createdDate };
          // this.taskInstanceList.push(processObj);
      },
      methods: {
          async  checkTaskDetail (record) {
              // 1.判断当前任务的任务负责人是否是人当前登录人
              // 2.是的话判断任务是否进行中，进行中则跳转到我的任务列表，不是的话就弹出任务详情
              // console.log(record);
              if (this.readOnly) {
                  return;
              }
              if (record.taskUser && record.taskUser.userId === this.currentUserInfo.userId) {
                  // 跳转到任务，并打开详情
                  const loading = this.$loading({
                      lock: true,
                      text: 'Loading',
                      spinner: 'el-icon-loading',
                      background: 'rgba(0, 0, 0, 0.7)'
                  });
  
                  let taskInfo = await getProcessTaskDetail(record.id);
                  loading.close();
                  let processTaskStr = {};
                  processTaskStr.processInstanceId = this.processInstanceId;
                  processTaskStr.processInstanceName = this.processInstanceName;
                  processTaskStr.taskInstanceId = record.id;
                  processTaskStr.taskName = record.name;
                  processTaskStr.taskState = taskInfo.taskState;
                  let processTaskJson = JSON.stringify(processTaskStr);
                  sessionStorage.setItem('navToTaskList', processTaskJson);
                  // console.log(this.isFromBusTab);
                  // 跳转页面
                  if (this.isFromBusTab) { // 来源于新版的应用tab
                      this.$emit('navToBusiniessTaskTab');
                  } else {
                      this.$emit('navToMyTaskMyAssignee');
                  }
              } else {
                  // this.$message({message: '此处只能快速跳转自己负责的任务', type: 'warning'});
                  this.showTaskDetailDialog(record);
              }
          },
          async showTaskDetailDialog (record) {
              const loading = this.$loading({
                  lock: true,
                  text: 'Loading',
                  spinner: 'el-icon-loading',
                  background: 'rgba(0, 0, 0, 0.7)'
              });
              let instances = await getProcessInstancesDetail(record.processInstanceId);
              loading.close();
              // 流程发起人、负责人、抄送人可查看任务详情
              let isCopyUser = false;
              if (instances.copyUserList && instances.copyUserList.length > 0) {
                  // 当前登录人是否是抄送人
                  for (let item of instances.copyUserList) {
                      if (this.currentUserInfo.userId === item.copyUserId) {
                          isCopyUser = true;
                      }
                  }
              }
              if (this.currentUserInfo.userId === instances.startedBy.id ||
                  (instances.assigneeUserId !== undefined && instances.assigneeUserId !== '' && instances.assigneeUserId === this.currentUserInfo.userId) ||
                  isCopyUser) {
                  this.isShowTaskDetail = false;
                  const loading = this.$loading({
                      lock: true,
                      text: 'Loading',
                      spinner: 'el-icon-loading',
                      background: 'rgba(0, 0, 0, 0.7)'
                  });
                  this.taskInfo = await getProcessTaskDetail(record.id);
                  setTimeout(() => {
                      this.$refs.taskDetailRef._initFormData();
                  }, 0);
                  loading.close();
                  this.isShowTaskDetail = true;
              } else {
                  this.$message({message: '此处只能快速跳转自己负责的任务', type: 'warning'});
              }
          },
          async sendUrgeMessage (row) {
              // console.log(row);
              let urgeMessageBO = {
                  msgType: 0, // 催办消息类型：0流程、1审批
                  processInstanceId: row.processInstanceId,
                  processInstanceName: this.processInstanceName,
                  taskInstanceId: row.id,
                  taskName: row.name,
                  receivedUserIds: row.assignee.id,
                  receivedUserNames: row.assignee.trueName
              };
              if (row.assignee && row.assignee.id) {
                  this.$confirm('您确定要给当前任务负责人【' + row.assignee.trueName + '】发送催办消息吗？', '提示', {
                      confirmButtonText: '确定',
                      cancelButtonText: '取消',
                      type: 'warning'
                  }).then(async (res) => {
                      let loading = this.$loading({
                          lock: true,
                          text: 'Loading',
                          spinner: 'el-icon-loading',
                          background: 'rgba(0, 0, 0, 0.7)'
                      });
                      await sendUrgeMessage(urgeMessageBO);
                      this.$emit('refresh');
                      loading.close();
                  }).catch(() => {});
              } else {
                  this.$message({message: '当前任务尚未设置负责人，请联系流程负责人处理', type: 'warning'});
              }
          }
      }
  };
</script>

<style lang="less">
</style>



// WEBPACK FOOTER //
// src/pages/process/MyProcess/CurrentTasksColumn.vue